import { Component, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouteSummary } from 'src/app/core/models/operations';
import { AddRouteComponent } from './add-route/add-route.component';
import { CONSTS } from './table-add-route.constants';

@Component({
  selector: 'app-table-add-route',
  templateUrl: './table-add-route.component.html',
  styleUrl: './table-add-route.component.scss',
  standalone: false,
})
export class TableAddRouteComponent {
  addRouteEvent = output<RouteSummary>();

  readonly CONSTS = CONSTS;

  constructor(private readonly dialog: MatDialog) {}

  clickAddRoute() {
    this.dialog
      .open(AddRouteComponent, {
        disableClose: true,
      })
      .afterClosed()
      .subscribe((value: RouteSummary) => {
        if (value) {
          this.addRouteEvent.emit(value);
        }
      });
  }
}
